<template>
	<hr v-bind:classes="classes"/>
</template>

<script>
	export default {
		name: "DisplayHr",
		props:{
			element: {type: Object},
		}, 
		computed: {
			classes(){
				var object = {}
				object[this.element.attrs.padding] = this.element.attrs.padding ? true : false;
				object[this.element.attrs.margin] = this.element.attrs.margin ? true : false;
				return object;
			},
		}
	}
</script>